import React, { useEffect } from 'react';
import { RULES, HOME } from '../../../constants/routes';
import { Link } from 'gatsby';

function Landing() {

    return (
      <div className="landing container">
        {/* <h1>Welcome to Buckley's Virtual Harvest Gram Site</h1> */}
        
        <div className='main-title'>
          Send a <br/> Valentine
        </div>
        <Link style={{textDecoration: 'none'}} className='main-button' to={HOME}>
          <Link className='main-button-text'><div>Let's Go</div></Link>
        </Link>
        <img className='heart-image' src={require('../../../assets/heart-arrow.svg')} />
        {/* <div className='rules-info'>
          Before you send a gram: read the <Link to={RULES}>community guidelines</Link>
        </div>
        <Link style={{textDecoration: 'none'}} className='send-button' to={HOME}>
          <img className='button-image' src='/icons/icon-512x512.png?v=5301b18271d1dd208c47d15ac68112f5'/>
          <Link className='send-button-text'><div>SEND A GRAM</div></Link>
          </Link>
      <div style={{height:100}}></div> */}
      </div>
    );
  
}

export default Landing;
